import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import store from "../store";

export const SentryService = {
    init(router) {
        console.log("sentry connected");

        Sentry.init({
            dsn: process.env.VUE_APP_SENTRY_DSN,
            logErrors: true,
            environment: "development, frontend",
            attachProps: true,
            trackComponents: true,
            tracingOptions: {
                trackComponents: true,
            },
            tracesSampleRate: 1.0,
            integrations: [
                new Integrations.BrowserTracing({
                    routingInstrumentation: Sentry.vueRouterInstrumentation(
                        router
                    ),
                    tracingOrigins: ["localhost", "my-site-url.com", /^\//],
                }),
            ],
        });
    },
    updateUserInformation() {
        console.log("update sentry informations");

        const user = store.getters["GET_CUSTOMER_DATA"];

        if (user) {
            Sentry.setTag("userId", user.id);
            Sentry.setTag("userName", user.full_name);
        }
    },
    sendError({ message, jsonObject }) {
        Sentry.addBreadcrumb({
            category: "jsonObject",
            message: JSON.stringify(jsonObject),
            level: "info",
        });
        Sentry.captureMessage(`message:${message}`);
    },
};
